export default function MarketingData() {
    return [
        {
            text: [
                {
                    title: "Protection for your most valuable asset – your income",
                    paragraphs: ["Disability income insurance is protection for your most valuable asset - your income. If an injury or illness kept you away from work - and your paycheck - for a period of time, who would pay your mortgage and other daily living expenses? Whether you’re out of work for a couple of months or a couple of years, disability insurance will pay a portion of your salary to keep you on solid financial footing."],
                }
            ]
            ,
            image: "/product-landing/disa/circle2.png"
        }
        ,
        {
            text: [
                {
                    title: "How does disability insurance work?",
                    paragraphs: ["Much like your car insurance protects you and your vehicle in the event of damage or injury, disability insurance provides a safety net if you’re unable to work due to a health concern or injury. With disability coverage, a portion of your income will be replaced so you can focus on getting well instead of worrying about paying bills."],
                }
            ]
            ,
            image: "/product-landing/disa/circle3.png"
        },
        {
            text: [
                {
                    title: "Who needs disability insurance?",
                    paragraphs: ["Don’t think it won’t happen to you. If you and your family rely on your income for daily expenses like the mortgage, food and other bills, you need this coverage. We can help you find affordable coverage that will give your family peace of mind in the event of accident or illness."],
                }
            ]
            ,
            image: "/product-landing/disa/circle4.png"
        }
    ]
}